import { Typography } from '@mui/material';
import useTrackPageLoad from 'hooks/useTrackPageLoad';
import DefaultSubtitle from 'pages/headliner/components/DefaultSubtitle';
import { useGetSocialStatsSummary } from 'pages/headliner/state';
import TableContainer from 'pages/headliner/TableContainer';
import { TABLE_PAGE_HEADER } from './constants';
import TableCard from './TableCard';

type TableContainerProps = {};

const AllVideoTableContainer: React.FC<TableContainerProps> = () => {
  const { data: stats } = useGetSocialStatsSummary();
  const [socialStats, youtubeStats] = stats ?? [];

  useTrackPageLoad({
    section: 'Studio',
    page: 'AllVideos',
    state: 'Populated',
  });

  return (
    <TableContainer
      title={
        <>
          <Typography variant="h1" gutterBottom>
            {TABLE_PAGE_HEADER}
          </Typography>
          <Typography variant="h2" gutterBottom>
            <DefaultSubtitle />
          </Typography>
        </>
      }
      youTubeStats={youtubeStats}
      socialStats={socialStats}
    >
      <TableCard />
    </TableContainer>
  );
};
export default AllVideoTableContainer;
